import { render, staticRenderFns } from "./EasyTable.vue?vue&type=template&id=811d63bc&scoped=true&"
import script from "./EasyTable.vue?vue&type=script&lang=js&"
export * from "./EasyTable.vue?vue&type=script&lang=js&"
import style0 from "./EasyTable.vue?vue&type=style&index=0&id=811d63bc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811d63bc",
  null
  
)

export default component.exports